import React from 'react'
import { withStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';

const styles = theme => ({
});

const InputDisplay = ({classes, idName, labelText, value, isDisabled}) => {
  return (
    <div>
      <TextField
          disabled={isDisabled}
          id={idName}
          label={labelText}
          margin="normal"
          value={value}
          fullWidth
        />
    </div>
  )
}

export default withStyles(styles)(InputDisplay);



// WEBPACK FOOTER //
// ./src/components/Steps/InputDisplay.js